import ThreeDotLoading from 'components/ui/ThreeDotLoading';
import { useEffect, useRef, useState } from 'react';

function PasswordInputModal({ isOpen, onClose, onConfirm, title, description, isLoading }) {
  const inputRef = useRef(null);
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    const t = setTimeout(() => inputRef.current?.focus(), 0);

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      clearTimeout(t);
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [isOpen, onClose]);
  useEffect(() => {
    if (isOpen) setPassword('');
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="password-modal-title"
    >
      {/* Backdrop */}
      <button
        aria-label="Close modal"
        onClick={onClose}
        className="absolute inset-0 cursor-default bg-black/50"
      />

      {/* Panel */}
      <div className="relative z-10 w-full max-w-md rounded-lg border border-slate-200 bg-white shadow-xl">
        <div className="border-b border-slate-200 px-5 py-4">
          <h2 id="password-modal-title" className="text-base font-semibold text-slate-900">
            {title}
          </h2>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            onConfirm(password);
          }}
          className="px-5 py-4"
        >
          <p className="text-sm text-slate-600">{description}</p>

          <div className="mt-4">
            <label htmlFor="password" className="block text-sm font-medium text-slate-700">
              Password
            </label>
            <input
              ref={inputRef}
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              className="mt-2 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none ring-0 placeholder:text-slate-400 focus:border-slate-400 focus:ring-2 focus:ring-slate-200"
            />
          </div>

          <div className="mt-6 flex items-center justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="relative w-30 rounded-md bg-blue-500 px-4 py-2 text-sm font-medium text-white"
              disabled={!password || isLoading}
            >
              <span className={isLoading ? 'invisible' : 'visible'}>Continue</span>

              {isLoading && (
                <span className="absolute inset-0 flex items-center justify-center">
                  <ThreeDotLoading />
                </span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PasswordInputModal;
